





































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";


@Component({
  components: {
  }
})

export default class AddPage extends Vue 
{
    private completion : (() => void) | null = null;
    private cancelation : (() => void) | null = null;
    private isVisible = false;

    public open(completion : () => void, cancelation : () => void)
    {
        this.completion = completion;
        this.cancelation = cancelation;
        this.isVisible = true;
    }

    private onOk() 
    {
        this.isVisible = false;
        if(this.completion) this.completion();
    }

    private onCancel()
    {
        this.isVisible = false;
        if(this.cancelation) this.cancelation();
    }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
}
